
import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BootstrapTooltip from 'react-bootstrap/Tooltip';

import './styles.css';

function TooltipSuggestion ({ show, children, handleClick }) {
  if (!show) {
    return children;
  }

  return (
    <span role="button" className="sc_tenant-card_tooltip-suggestion" onClick={handleClick}>
      <OverlayTrigger
        defaultOverlayShown
        placement="bottom"
        overlay={
          <BootstrapTooltip id={`${name || new Date().getTime()}-env`}>
            Click here to assign the Environment Tag or run the Production
            Check
          </BootstrapTooltip>
        }
      >
        {children}
      </OverlayTrigger>
    </span>
  );
}

TooltipSuggestion.propTypes = {
  show: PropTypes.bool,
  handleClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default TooltipSuggestion;
